import React from 'react';
import { cn } from '@/lib/cn';
function Section({ settings, className, children, ...props }) {
  return (
    <section
      className={cn('block-section', resolveSettings(settings), className)}
      {...props}>
      {children}
    </section>
  );
}

export default Section;

function resolveSettings(settings) {
  const settingsMap = {
    padding_top: {
      sm: 'pt-10',
      md: 'pt-14 lg:pt-16',
      lg: 'pt-20 lg:pt-24',
      xl: 'pt-24 lg:pt-32',
      '2xl': 'pt-44 lg:pt-64',
    },
    padding_bottom: {
      sm: 'pb-10',
      md: 'pb-14 lg:pb-16',
      lg: 'pb-20 lg:pb-24',
      xl: 'pb-24 lg:pb-32',
      '2xl': 'pb-44 lg:pb-64',
    },
    margin_top: {
      sm: 'mt-5',
      md: 'mt-10',
      lg: 'mt-16',
      xl: 'mt-24',
    },
    margin_bottom: {
      sm: 'mb-5',
      md: 'mb-10',
      lg: 'mb-16',
      xl: 'mb-24',
    },
    variant: {
      gray: 'bg-gray-50',
      dark: 'bg-gray-950 text-white',
      black: 'bg-gray-1000 text-white',
    },
  };

  if (!settings) {
    return [];
  }

  return Object.entries(settings).reduce((classes, [key, value]) => {
    const settingMap = settingsMap[key];
    if (settingsMap[key]) {
      const cssClass = settingMap[value];
      if (cssClass) {
        classes.push(cssClass);
      }
    }
    return classes;
  }, []);
}
